import * as React from 'react';
import styled from 'styled-components';
import { ConfirmButtons } from '../ConfirmButtons';
import { EditableSectionHeader } from '../EditableSectionHeader';
import {
  IEditableSectionProps,
  IEditableSectionState
} from './EditableSection.types';
import { switchEditMode, setModel } from './EditableSection.logic';

const EditableConfirmButtons = styled(ConfirmButtons)`
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  width: 100%;
  margin-top: 32px;
`;

const EditableSection: React.FC<IEditableSectionProps> = (
  props: IEditableSectionProps
) => {
  const {
    model,
    modelId,
    onChange,
    onCancel,
    children,
    title,
    className,
    validator,
    enableValidation,
    testId
  } = props;
  const [state, setState] = React.useState<IEditableSectionState>({
    model: {},
    oldCopy: {},
    editMode: false
  });
  React.useEffect(
    () =>
      setState({
        oldCopy: { ...model },
        model: { ...model }
      }),
    [model]
  );
  const handleSetModel = (newModel: any) =>
    setModel(newModel, state, setState, onChange, modelId);

  return (
    <div className={className ?? ''}>
      <div
        className={`form-steps-edit-mode ${
          state.editMode && !!modelId ? 'enabled' : 'disabled'
        }`}
      >
        <EditableSectionHeader
          icon="icons/form-edit.svg"
          addMode={!modelId}
          onEdit={() => switchEditMode(state, setState)}
          testId={testId}
        >
          {title}
        </EditableSectionHeader>
        {children(
          state.model,
          !state.editMode && !!modelId,
          handleSetModel,
          enableValidation ? validator(state.model) : []
        )}
        {state.editMode && !!modelId ? (
          <EditableConfirmButtons
            onCancel={() => {
              if (onCancel) {
                onCancel();
              }
              switchEditMode(state, setState);
            }}
            onConfirm={() => {
              if (!validator(state.model).length) {
                if (onChange) {
                  onChange(state.model);
                }
                switchEditMode(state, setState, true);
              }
            }}
            confirmButtonText="Save changes"
            confirmButtonTestId={`${testId}_save_changes_button`}
            cancelButtonTestId={`${testId}_cancel_button`}
          />
        ) : null}
      </div>
    </div>
  );
};

export default EditableSection;
